import { Injector } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CrudService } from './crud.service';
import { Menu } from '../models/rights/menu';
import { User } from '../models/user';
import { AuthenticationService } from './authentication.service';

export abstract class AUsersService<T extends User> extends CrudService<T>  {
    private readonly _service: AuthenticationService;

    constructor(baseUrl: string, injector: Injector, type: new () => T) {
        super(baseUrl, injector, type);

        this._service = injector.get(AuthenticationService);
    }

    definePassword(credential: any) {
        let request: HttpRequest<any> = this.getRequest(this.baseUrl, "POST", this._service.currentUser.id, credential);
        request = request.clone({ url: request.url + "/P@$sw0rd" });
        return this.executeQuery<any>(request);
    }

    resetPassword(user: User): any {
        let request: HttpRequest<any> = this.getRequest(this.baseUrl, "POST", user.id);
        request = request.clone({ url: request.url + "/Râ¬$3tP@s$w0Rd" });
        return this.executeQuery<any>(request);
    }

    getAvailableMenus(): Observable<Menu[]> {
        let request: HttpRequest<any> = this.getRequest(this.baseUrl, "GET", this._service.currentUser.id);
        request = request.clone({ url: request.url + "/menus" });
        return this.executeQuery<any>(request)
            .pipe(
                map(res => this.convertToT(Menu, res) as Menu[])
            );
    }
}

